(() => {
  const normalizeFilename = (value) => {
    if (!value) return '';
    try {
      const clean = value.split('|')[0].split('?')[0].split('#')[0];
      return decodeURIComponent(clean.substring(clean.lastIndexOf('/') + 1)).toLowerCase();
    } catch (_error) {
      return value.split('/').pop().split('?')[0].toLowerCase();
    }
  };

  const init = () => {
    const mapNode = document.getElementById('MatchBooxPageAssetMap');
    if (!mapNode) return;

    let assetMap = {};
    try {
      assetMap = JSON.parse(mapNode.textContent || '{}');
    } catch (_error) {
      return;
    }

    const pageContent = document.querySelector('.mb-page-content');
    if (!pageContent) return;
    const assetEntries = Object.entries(assetMap);
    const localAssetFor = (source) => {
      const filename = normalizeFilename(source);
      if (assetMap[filename]) return assetMap[filename];
      const carouselNumber = filename.match(/^mb0*(\d{1,3})-(?:boek|serie)-carrousel/i)?.[1];
      if (!carouselNumber) return '';
      const number = carouselNumber.padStart(3, '0');
      return assetEntries.find(([name]) => new RegExp(`-mb-${number}-matchboox\\.(?:jpe?g|png|webp)$`, 'i').test(name))?.[1] || '';
    };

    /* Geïmporteerde pagina's bevatten soms een extra Shopify-titel en intro boven
       de eerste scheidingslijn. Verwijder die hele aanloop, ook wanneer de lijn
       in een geneste container staat. */
    const firstRule = pageContent.dataset.pageHandle === 'contact' ? null : pageContent.querySelector('hr');
    if (firstRule) {
      const range = document.createRange();
      const preservedIntro = pageContent.querySelector(':scope > .mb-over-matchboox-intro');
      if (preservedIntro) range.setStartAfter(preservedIntro);
      else range.setStart(pageContent, 0);
      range.setEndAfter(firstRule);
      range.deleteContents();
      while (
        pageContent.firstElementChild
        && !pageContent.firstElementChild.textContent.trim()
        && !pageContent.firstElementChild.querySelector('img, video, iframe, svg')
      ) {
        pageContent.firstElementChild.remove();
      }
    }

    const repairImage = (image) => {
      if (!(image instanceof HTMLImageElement)) return;
      /* De makersoverzichten worden in V125 rechtstreeks gekoppeld aan
         Shopify-afbeelding 1. Laat de oude import-fallback die bron niet
         opnieuw vervangen. */
      if (
        image.dataset.mbShopifyPrimary === 'true'
        || (
          ['auteurs', 'illustratoren'].includes(pageContent.dataset.pageHandle)
          && image.closest('.mb-book-card')
        )
      ) return;
      if (!/matchboox/i.test(image.alt || '')) {
        const pageHeading = pageContent.querySelector('h1, h2')?.textContent?.trim();
        image.alt = image.alt?.trim()
          ? `${image.alt.trim()} – MatchBoox`
          : `${pageHeading || document.title} – MatchBoox afbeelding`;
      }
      const legacySources = [
        image.getAttribute('src'),
        image.getAttribute('data-src'),
        ...(image.dataset.fallbacks || '').split('|'),
      ].filter(Boolean);
      const localSources = legacySources
        .map(localAssetFor)
        .filter((source, index, sources) => source && sources.indexOf(source) === index);

      if (!localSources.length) return;
      if (image.dataset.mbAssetApplied === localSources[0] && image.getAttribute('src') === localSources[0]) return;

      image.removeAttribute('onerror');
      image.onerror = null;
      image.removeAttribute('srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('hidden');
      image.style.removeProperty('display');
      image.dataset.mbAssetApplied = localSources[0];
      let sourceIndex = 0;
      const showNextLocalSource = () => {
        sourceIndex += 1;
        if (sourceIndex < localSources.length) image.src = localSources[sourceIndex];
      };
      image.addEventListener('error', showNextLocalSource, { once: true });
      image.src = localSources[0];
      image.closest('.mb-book-image')?.classList.remove('is-missing');
    };

    const repairTree = (root) => {
      if (root instanceof HTMLImageElement) repairImage(root);
      root.querySelectorAll?.('img').forEach(repairImage);
    };

    repairTree(pageContent);

    /* De cadeau- en makerspagina's bouwen enkele kaarten pas na het laden.
       Controleer daarom ook later toegevoegde afbeeldingen. */
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') repairImage(mutation.target);
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) repairTree(node);
        });
      });
    });
    observer.observe(pageContent, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'data-src', 'data-fallbacks'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
